"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceModifier = void 0;
var PriceModifier = /** @class */ (function () {
    function PriceModifier() {
    }
    PriceModifier.bulkPrice = function (isFoil, isPlayset, bulkPrices) {
        var price;
        if (isFoil && bulkPrices.foilPrice)
            price = bulkPrices.foilPrice;
        else
            price = bulkPrices.price;
        if (!price)
            price = 0.1;
        return isPlayset ? price * 4 : price;
    };
    PriceModifier.getPlaysetCoefficient = function (pricedArticlePlayset, marketArticlePlayset) {
        if (pricedArticlePlayset === marketArticlePlayset)
            return 1;
        else if (pricedArticlePlayset > marketArticlePlayset)
            return 4;
        else
            return 0.25;
    };
    PriceModifier.modifyPrice = function (price, pricingStrategy, playsetCoefficient, rarity, isFoil, bulkPricing, priceFloor, priceCeiling) {
        if (playsetCoefficient === void 0) { playsetCoefficient = 1; }
        if (!price)
            return { finalPrice: null, usedBulkPrice: false };
        var finalPrice = price * playsetCoefficient;
        var hitDecreaseCap = false;
        var hitIncreaseCap = false;
        if (pricingStrategy.modifier.kind === 'number') {
            finalPrice = Math.round(finalPrice * 100 - pricingStrategy.modifier.value) / 100;
        }
        else if (pricingStrategy.modifier.kind === 'percent') {
            finalPrice = Math.round(finalPrice * pricingStrategy.modifier.value) / 100;
        }
        finalPrice = Math.max(finalPrice, 0.02);
        var usedBulkPrice = false;
        if (bulkPricing) {
            if (!bulkPricing)
                return { finalPrice: null, usedBulkPrice: false };
            var bulkPriceValue = PriceModifier.bulkPrice(isFoil, playsetCoefficient === 4, bulkPricing[rarity] ? bulkPricing[rarity] : bulkPricing[1]);
            if (bulkPriceValue > finalPrice) {
                finalPrice = Number(bulkPriceValue);
                usedBulkPrice = true;
            }
        }
        if (priceFloor && finalPrice < priceFloor) {
            finalPrice = priceFloor;
            hitDecreaseCap = true;
        }
        if (priceCeiling && finalPrice > priceCeiling) {
            finalPrice = priceCeiling;
            hitIncreaseCap = true;
        }
        return { finalPrice: finalPrice, usedBulkPrice: usedBulkPrice, hitDecreaseCap: hitDecreaseCap, hitIncreaseCap: hitIncreaseCap };
    };
    return PriceModifier;
}());
exports.PriceModifier = PriceModifier;
//# sourceMappingURL=priceModifier.js.map